const e={Xxs:"0.25rem","2xs":"0.25rem",Xs:"0.5rem",Sm:"0.75rem",Base:"1rem",Lg:"1.25rem",Xl:"2rem",Xxl:"3rem","2xl":"3rem"};export{e as Spacing};
